import { LOAD_TRANSLATED_TEXTS, RESET_TRANSLATED_TEXTS } from "../action";
import { translatedTexts } from "./translated-texts-store";

const initialState = translatedTexts;

function translatedTextsReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_TRANSLATED_TEXTS:
      return Object.assign({}, state, action.payload);
    case RESET_TRANSLATED_TEXTS:
      return initialState;
    default:
      return state;
  }
}

export default translatedTextsReducer;
